import { ui } from '@hf/client-core/ui-model/store';

/** F3 frame/net stats overlay. */
export function StatsOverlay() {
  const d = ui.debug.value;
  if (!d || !ui.settings.value.showStats) return null;
  const lines = [
    `fps ${d.fps.toFixed(0)}  tick ${d.tick}`,
    `sim ${d.tickMs.toFixed(2)}ms  draw ${d.renderMs.toFixed(2)}ms  drops ${d.drops}`,
    d.rttMs !== undefined
      ? `rtt ${d.rttMs.toFixed(0)}ms  delay ${d.inputDelay ?? '-'}  rb ${d.rollback ?? 0}`
      : '',
    d.hash ? `hash ${d.hash}` : '',
  ].filter(Boolean);
  return <div class="hf-stats">{lines.join('\n')}</div>;
}
